import React, {Component} from 'react';
import {Modal} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import FormFieldValidationError from "../../../../Common/FormFieldValidationError/FormFieldValidationError";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import {Link} from "react-router-dom";
import UserProfileNavBar from "../../UserProfileNavBar";


class UserProfileSettingMobile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            userInfo: '',
            userName: '',
            userEmail: '',
            userContact: '',
            userAddress: '',
            japaneseFirstName: '',
            japaneseLastName: '',
            nameValidationError: "",
            jpFnameValidationError: "",
            jpLnameValidationError: "",
            contactValidationError: "",
            addressValidationError: "",
            emailValidationError: "",

            showSuccess: false,
            showSuccessMsg: ""
        };

        this.getUserDetails = this.getUserDetails.bind(this);
        this.handleEditSuccessClose = this.handleEditSuccessClose.bind(this);

        this.onInputChange = this.onInputChange.bind(this);
        this.validateName = this.validateName.bind(this);
        this.validateContact = this.validateContact.bind(this);
        this.validateAddress = this.validateAddress.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.updateProfileInfo = this.updateProfileInfo.bind(this);
    }

    handleEditSuccessClose = () => {
        this.setState({
            showSuccess: false
        })
    };

    getUserDetails = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/' + this.props.userId, axiosConfig)
            .then((res) => {
                console.log("MOBILE USER ====> ", res.data);
                this.setState({
                    userName: res.data.username,
                    userEmail: res.data.email,
                    userContact: res.data.phone,
                    userAddress: res.data.primaryAddress,
                    japaneseFirstName: res.data.japaneseFirstName,
                    japaneseLastName: res.data.japaneseLastName,
                    billingAddress: res.data.billingAddress,
                    billingAddressId: "-1",
                    shippingAddressId: "-1",
                    shippingAddress: res.data.shippingAddress,
                    userRole: res.data.userRole,
                    status: res.data.status
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };


    validateName = (type, name) => {
        if (name === "") {
            if (type === 1) {
                this.setState({
                    nameValidationError: "app.validation.user-profile.user-edit-profile.empty-name"
                });
            } else if (type === 2) {
                this.setState({
                    jpFnameValidationError: "app.validation.user-profile.user-edit-profile.empty-name"
                });
            } else {
                this.setState({
                    jpLnameValidationError: "app.validation.user-profile.user-edit-profile.empty-name"
                });
            }
            return false;
        }
        return true;
    };

    validateContact = () => {
        let contact = this.state.userContact;
        let pattern = /^[0-9]*$/;
        if (contact === "") {
            this.setState({
                contactValidationError: "app.validation.user-profile.user-edit-profile.empty-contact"
            });
            return false;
        }
        return true;
    };

    validateAddress = () => {
        let address = this.state.userAddress;
        if (address === "") {
            this.setState({
                addressValidationError: "app.validation.user-profile.user-edit-profile.empty-address"
            });
            return false;
        }
        return true;
    };

    validateEmail = () => {
        let email = this.state.userEmail;
        let pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;

        if (email === "" || !email.match(pattern)) {
            this.setState({
                emailValidationError: "app.validation.user-profile.user-edit-profile.empty-email"
            });
            return false;
        }
        return true;
    };

    updateProfileInfo = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.put(RESOURCE_BASE_URL + 'api/users/' + this.props.userId
            , {
                name: this.state.userName,
                email: this.state.userEmail,
                phone: this.state.userContact,
                primaryAddress: this.state.userAddress,
                japaneseFirstName: this.state.japaneseFirstName,
                japaneseLastName: this.state.japaneseLastName,
                billingAddress: this.state.billingAddress,
                billingAddressId: "-1",
                shippingAddressId: "-1",
                shippingAddress: this.state.shippingAddress,
                userRole: this.state.userRole,
                status: this.state.status
            }, axiosConfig)
            .then((res) => {
                this.getUserDetails(this.props.userId);
                this.setState({
                    showSuccess: true,
                    showSuccessMsg: "プロファイルが正常に更新されました。"
                })
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({
                    showSuccess: true,
                    showSuccessMsg: "プロファイルの更新に失敗しました。"
                })
            });

    };

    onSubmit = event => {

        let nameOk = true;
        let contactOk = this.validateContact();
        let addressOk = this.validateAddress();
        // let emailOk = this.validateEmail();
        let emailOk = true;
        let jpFName = this.validateName(2, this.state.japaneseFirstName);
        let jpLName = this.validateName(3, this.state.japaneseLastName);

        if (nameOk && contactOk && addressOk && emailOk && jpFName && jpLName) {
            this.updateProfileInfo();
            // this.handleClose();
        }

    };

    onInputChange = event => {
        // console.log("NAME DUO ==== >", event.target.name);
        this.setState({
            [event.target.name]: event.target.value,
            nameValidationError: "",
            contactValidationError: "",
            addressValidationError: "",
            emailValidationError: "",
            jpFnameValidationError: "",
            jpLnameValidationError: "",
        });
    };

    componentDidMount() {
        this.getUserDetails();

    }

    render() {
        return (
            <div>
                <div className="row collapse-user-profile-div">
                    <UserProfileNavBar userId = {this.props.userId}
                                       userData={this.props.userData}/>
                </div>
                <div className="text-center-responsive collapse-light-green inquiry-list-height ">
                    ユーザー情報設定
                </div>
                <div className="padding-div-user-profile">
                    {/*<div className="collapse-light-green inquiry-list-height ">*/}
                    {/*ユーザー情報設定*/}
                    {/*</div>*/}


                    <div className="edit-profile-div color-text">
                        <div className="row">
                            <br/>
                            <div className="no-padding col-md-2 text-right  data-label-padding">
                                ユーザー名

                            </div>
                            <div className="col-md-9">
                                {this.state.userName}
                            </div>
                        </div>
                        <div className="form-row-spacer"></div>
                        <div className="row">
                            <div className="no-padding col-md-2 text-right  data-label-padding">
                                <FormattedMessage id="app.user-profile.user-profile-edit.email"
                                                  defaultMessage="Email"
                                                  description=""/>
                            </div>
                            <div className="col-md-9">
                                {this.state.userEmail}
                            </div>
                        </div>

                        <div className="form-row-spacer"></div>

                        <div className="row">
                            <div className="no-padding col-md-2 text-right  data-label-padding">
                                <FormattedMessage id="app.user-profile.user-profile-edit.phone"
                                                  defaultMessage="Phone"
                                                  description=""/>
                            </div>
                            <div className="col-md-9">
                                <input type="text" name="userContact" value={this.state.userContact}
                                       className="form-control input-sm" onChange={this.onInputChange}/>

                                <FormFieldValidationError errors={this.state.contactValidationError}/>

                            </div>
                        </div>

                        <div className="form-row-spacer"></div>

                        <div className="row">
                            <div className="no-padding col-md-2 text-right  data-label-padding">
                                姓
                            </div>
                            <div className="col-md-9">
                                <input type="text" name="japaneseLastName" value={this.state.japaneseLastName}
                                       className="form-control input-sm" onChange={this.onInputChange}/>

                                <FormFieldValidationError errors={this.state.jpLnameValidationError}/>

                            </div>
                        </div>

                        <div className="form-row-spacer"></div>

                        <div className="row">
                            <div className="no-padding col-md-2 text-right  data-label-padding">
                                名
                            </div>
                            <div className="col-md-9">
                                <input type="text" name="japaneseFirstName" value={this.state.japaneseFirstName}
                                       className="form-control input-sm" onChange={this.onInputChange}/>

                                <FormFieldValidationError errors={this.state.jpFnameValidationError}/>


                            </div>
                        </div>

                        <div className="form-row-spacer"></div>

                    </div>
                    <div className="edit-profile-div">
                        <div className="custom-col-6 add-padding-user-profile-responsive">
                            <button className="btn btn-primary bottom-button btn-width-userProfile"
                                    onClick={this.onSubmit}>
                                <FormattedMessage id="app.user-profile.user-profile-edit.save"
                                                  defaultMessage="Save"
                                                  description=""/>

                            </button>
                        </div>
                        <div className="custom-col-6 add-padding-user-profile-responsive ">
                            <Link to="/profile">
                                <a className="btn btn-default bottom-button btn-width-userProfile anchor-userProfile">
                                    戻る

                                </a>

                            </Link>
                        </div>


                    </div>


                    <Modal show={this.state.showSuccess}
                           onHide={this.handleEditSuccessClose}>
                        <Modal.Header closeButton
                                      onHide={this.handleEditSuccessClose}>
                            <div className="title-1 color-text">
                                更新プロファイル
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="color-text">
                                <div className="row">
                                    <div className="col-md-8  data-label-padding">
                                        {this.state.showSuccessMsg}
                                    </div>


                                </div>
                                <div className="form-row-spacer"></div>

                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="col-md-12">

                                <button className="btn col-md-2 pull-right btn-primary"
                                        onClick={this.handleEditSuccessClose}
                                >
                                    閉じる
                                </button>

                            </div>
                        </Modal.Footer>
                    </Modal>

                </div>
            </div>
        )
    }
}

export default UserProfileSettingMobile;



// WEBPACK FOOTER //
// ./src/components/Site/UserProfile/UserProfileInfo/UserProfileSettingMobile/UserProfileSettingMobile.js